import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Form } from '../_forms';
import {
  Action,
  CustomStepCategoryEnum,
  Funnel,
  FunnelInput,
  FunnelInputTypeEnum,
  FunnelStep,
  IntentConfirmationButtonText,
  OfferIntents,
  OfferStages,
  OfferTypes,
  Pager,
  PathNewStepSelection,
  StepCategory,
  OfferTypeLabels,
  PathStepsDescription,
} from '../_models';
import {
  AlertService,
  CancelReasonCategoryService,
  FunnelInputService,
  FunnelService,
  FunnelStepService,
  StepTemplateService,
  StorageService,
} from '../_services';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FunnelInputFieldsComponent } from '../funnel-input';
import {config} from '../../config/config';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './path-step.component.html',
  styleUrls: ['./path-step.component.scss'],
  selector: 'app-path-step',
})
export class PathStepComponent extends Form implements OnInit, OnDestroy {
  @Input('step') step: FunnelStep;
  @Input('funnel') funnel: Funnel;
  @Input('nextStepId') nextStepId: string | number;
  @Input('stepValidation') stepValidation;
  @Input('canBeDeleted') canBeDeleted: boolean = true;
  @Input('rejectResponseStep') rejectResponseStep: FunnelStep;
  @Input('acceptResponseStep') acceptResponseStep: FunnelStep;
  @Output('delete') onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output('onStepLoading') onStepLoading: EventEmitter<any> = new EventEmitter<any>();
  @Output('updateStepValidation') updateStepValidation: EventEmitter<any> = new EventEmitter<{
    type: string;
    isValid: boolean;
  }>();
  @Output('save') onSave: EventEmitter<any> = new EventEmitter<any>();

  public surveyCategories: StepCategory[] = [
    CustomStepCategoryEnum.Survey,
    CustomStepCategoryEnum.CancelOrderSurvey,
    CustomStepCategoryEnum.CancelTrialSurvey,
    CustomStepCategoryEnum.CancelSubSurvey,
    CustomStepCategoryEnum.ReturnSurvey,
    CustomStepCategoryEnum.PauseSurvey,
  ];
  protected type: FunnelInputTypeEnum;
  protected category: StepCategory;
  public stepTemplates: FunnelStep[] = [];
  public inputs: FunnelInput[] = [];
  public productFunnelInputsData = [];
  public cancelReasonCategories: any[] = [];
  public selectedTemplateId: string | number = null;
  public offers: Funnel[] = [];
  public troubleshooters: Funnel[] = [];
  public stepTemplateId: number | string = null;
  public selectedDownsellId: number | string = null;
  public offerIntentType = OfferIntents;
  public ResponsesArray: FunnelStep[] = [];
  public PathNewStepSelection = PathNewStepSelection;
  public activeStepType: PathNewStepSelection | null = null;
  public selectedInput: FunnelInput = null;
  public PathStepsDescription = PathStepsDescription;
  public storageListener: (event: StorageEvent) => void;
  @ViewChild(FunnelInputFieldsComponent, { static: false }) inputComponent: FunnelInputFieldsComponent;

  constructor(
    protected alertService: AlertService,
    protected router: Router,
    protected location: Location,
    protected formBuilder: FormBuilder,
    protected stepService: FunnelStepService,
    protected stepTemplateService: StepTemplateService,
    protected funnelService: FunnelService,
    protected inputService: FunnelInputService,
    protected modalService: NgxSmartModalService,
    protected storageService: StorageService,
    protected cancelReasonCategoriesService: CancelReasonCategoryService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.setForm(
      this.formBuilder.group({
        type: [this.type, Validators.required],
        category: [this.category, Validators.required],
        name: [null, Validators.required],
        label: [null],
        template: [null],
      })
    );

    this.stepService.setFunnelId(this.funnel.id);
    this.stepTemplateService
      .list({
        category__in: this.surveyCategories.join(','),
        offer_intent: this.getOfferIntentType(this.funnel.offer_intent),
        folder__isnull: true,
      })
      .subscribe((stepTemplates: Pager) => {
        this.stepTemplates = stepTemplates.results;
      });

    this.funnelService
      .list({
        offer_type: this.getOfferType(),
        offer_intent: this.funnel.offer_intent,
      })
      .subscribe((offers: Pager) => {
        this.offers = offers.results;
      });

    this.funnelService.list({ resourcetype: 'Troubleshooter' }).subscribe((troubleshooters: Pager) => {
      this.troubleshooters = troubleshooters.results;
    });

    this.stepTemplateId = this.step.template;

    this.ResponsesArray = [this.acceptResponseStep, this.rejectResponseStep];
    this.onStepSave(this.step);

    if (this.isConfirmation()) {
      this.step.content = '';
      this.stepService.get(this.step.id).subscribe((step: FunnelStep) => {
        this.step.content = step.content;
      });
    }

    if (this.isSurvey()) {
      this.fetchSurveyReasonCategories();
    }
  }

  setupStorageListener(): void {
    this.storageListener = (event: StorageEvent) => {
      const offerType = this.getOfferTypeLabel();
      const offerId = this.storageService.get(offerType);
      const surveyId = this.storageService.get('survey');

      if (offerId) {
        this.loading = true;

        this.funnelService.get(offerId).subscribe({
          next: (offer: any) => {
            this.updateOffers(offer);
            this.storageService.remove(offerType);
            this.loading = false;
          },
          error: (error) => {
            this.handleError(error);
            this.loading = false;
          },
        });
      } else if (surveyId) {
        this.loading = true;

        this.stepTemplateService
          .list({
            category__in: this.surveyCategories.join(','),
            offer_intent: this.getOfferIntentType(this.funnel.offer_intent),
            folder__isnull: true,
          })
          .subscribe(
            (stepTemplates: Pager) => {
              const newTemplate = stepTemplates.results.find((template) => template.id === surveyId);
              if (newTemplate) {
                this.stepTemplates.unshift(newTemplate);
                this.onTemplateChanged({ target: { value: newTemplate.id } });
              }
              this.storageService.remove('survey');
            },
            (error) => {
              this.handleError(error);
              this.loading = false;
            }
          );
      }
    };

    window.addEventListener('storage', this.storageListener);
  }

  getOfferTypeLabel(): string {
    return this.isUpsell() ? OfferTypeLabels[OfferTypes.Upsell] : OfferTypeLabels[OfferTypes.Downsell];
  }

  updateOffers(offer: any): void {
    this.offers.unshift(offer);
    this.inputs[0].product_funnels = [offer.id];
    this.onInputFieldUpdateAction(this.inputs[0].id, 'product_funnels', offer.id);
  }

  isUpsell() {
    return (
      this.step.type === FunnelInputTypeEnum.EnterProductFunnel &&
      this.step.category === CustomStepCategoryEnum.UpsellOrder
    );
  }

  showDragStep(stepType: PathNewStepSelection) {
    this.activeStepType = stepType;
  }

  hideDragStep(stepType: PathNewStepSelection) {
    if (this.activeStepType === stepType) {
      this.activeStepType = null;
    }
  }

  isSurvey() {
    return this.surveyCategories.indexOf(this.category) > -1;
  }

  isTroubleShooter() {
    return this.type === FunnelInputTypeEnum.EnterTroubleshooter;
  }

  isOfferSelected(offerId: number): boolean {
    return this.offers.some((offer) => offer.id === offerId) || !!this.selectedDownsellId;
  }

  isFunnelInputSelected(id: number): boolean {
    return this.productFunnelInputsData.some((input) => input.productFunnel === id);
  }

  isEnterProductPath() {
    return this.type === FunnelInputTypeEnum.EnterProductFunnel;
  }
  getSurveyStepCategory(offerIntent: number): number {
    const surveyStepCategoryMap = {
      [OfferIntents.CancelOrder]: CustomStepCategoryEnum.CancelOrderSurvey,
      [OfferIntents.ReturnOrder]: CustomStepCategoryEnum.ReturnSurvey,
      [OfferIntents.ReturnSubscription]: CustomStepCategoryEnum.ReturnSurvey,
      [OfferIntents.ReturnTrial]: CustomStepCategoryEnum.ReturnSurvey,
      [OfferIntents.CancelTrial]: CustomStepCategoryEnum.CancelTrialSurvey,
      [OfferIntents.CancelSubscription]: CustomStepCategoryEnum.CancelSubSurvey,
      [OfferIntents.CancelSubscriptionHold]: CustomStepCategoryEnum.CancelOrderSurvey,
      [OfferIntents.CancelRebillHold]: CustomStepCategoryEnum.CancelSubSurvey,
      [OfferIntents.CancelTrialHold]: CustomStepCategoryEnum.CancelOrderSurvey,
    };
    return surveyStepCategoryMap[offerIntent] || 0;
  }

  getOfferIntentType(type: OfferIntents): OfferIntents {
    const intentMap: Partial<Record<OfferIntents, OfferIntents>> = {
      [OfferIntents.CancelSubscriptionHold]: OfferIntents.CancelSubscription,
      [OfferIntents.CancelRebillHold]: OfferIntents.CancelSubscription,
      [OfferIntents.CancelTrialHold]: OfferIntents.CancelTrial,
      [OfferIntents.ReturnSubscription]: OfferIntents.ReturnOrder,
      [OfferIntents.ReturnTrial]: OfferIntents.ReturnOrder,
    };
    return intentMap[type] || type;
  }

  isConfirmation() {
    return [FunnelInputTypeEnum.Confirmation, FunnelInputTypeEnum.ConfirmationNo].indexOf(this.type) > -1;
  }

  isResponse() {
    return this.type === FunnelInputTypeEnum.InputActionStatus;
  }

  getOfferType() {
    const downsellOfferIntents = [
      OfferIntents.CancelOrder,
      OfferIntents.CancelSubscriptionHold,
      OfferIntents.CancelTrialHold,
      OfferIntents.ReturnOrder,
      OfferIntents.CancelSubscription,
      OfferIntents.CancelTrial,
      OfferIntents.ReturnSubscription,
      OfferIntents.ReturnTrial,
      OfferIntents.CancelRebillHold,
    ];
    const upsellOfferIntents = [OfferIntents.Upsell];

    if (downsellOfferIntents.indexOf(this.funnel.offer_intent) > -1 && !this.isUpsell()) {
      return OfferTypes.Downsell;
    }

    if (this.isUpsell()) {
      return OfferTypes.Upsell;
    }

    return OfferTypes.Support;
  }

  getPathType() {
    let offer_intent = this.funnel.offer_intent;
    return OfferStages[offer_intent];
  }

  navigateToStep(stepTemplates: FunnelStep[]) {
    if (stepTemplates.length && this.stepTemplateId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([
          '/steps',
          'survey',
          'category',
          OfferTypes.Survey,
          this.getSurveyStepCategory(this.funnel.offer_intent),
          'step',
          this.stepTemplateId,
        ])
      );
      window.open(url, '_blank');
    }
  }

  handleSurveyInputs(inputs: FunnelInput[]) {
    let parentInputs = {};

    inputs.forEach((input: FunnelInput) => {
      if (input.next_step) {
        parentInputs[input.next_step] = input;
      }
    });

    this.inputService
      .listAll({
        step__funnel: this.funnel.id,
        step__in: Object.keys(parentInputs).join(','),
        type: FunnelInputTypeEnum.EnterProductFunnel,
      })
      .subscribe(
        (productFunnelInputs: FunnelInput[]) => {
          productFunnelInputs.forEach((input: FunnelInput) => {
            const value = {
              id: input.id,
              productFunnel: input.product_funnels.length > 0 ? input.product_funnels[0] : null,
              step: input.step,
            };
            if (input.step in parentInputs) {
              value['parentInput'] = parentInputs[input.step].label;
              value['reasonCategory'] = parentInputs[input.step].reason_category;
            }
            this.productFunnelInputsData.push(value);
          });
          this.loading = false;
        },
        (error) => {
          this.handleError(error);
          this.loading = false;
        }
      );
  }

  fetchSurveyReasonCategories() {
    this.cancelReasonCategoriesService.list({page: 1, page_size: config.maxPageSize}).subscribe(
      (categories: Pager) => {
        this.cancelReasonCategories = categories.results;
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  getCancelCategoryName(categoryId: number): string | null {
    const category = this.cancelReasonCategories.find((x) => x.id === categoryId);
    return category ? category.name : null;
  }

  processStepInputs(inputs: FunnelInput[]) {
    if (this.isSurvey()) {
      this.handleSurveyInputs(inputs);
    } else if (this.isConfirmation()) {
      this.inputs = inputs;
    } else if (this.isTroubleShooter() || this.isEnterProductPath()) {
      this.inputs = inputs.filter(
        (input) =>
          [FunnelInputTypeEnum.EnterTroubleshooter, FunnelInputTypeEnum.EnterProductFunnel].indexOf(input.type) > -1
      );
    }
  }

  onTemplateChanged(event) {
    const dropdown = event.target as HTMLSelectElement;

    if (dropdown.value === 'new') {
      this.setupStorageListener();
      this.redirectToCreateStep('survey');
      this.storageService.set('isNewSurvey', true);
      dropdown.value = null;
    } else {
      const template_id = dropdown.value;
      this.stepTemplateId = template_id;
      this.updateValidationState(template_id);
      if (template_id !== this.selectedTemplateId) {
        this.loading = true;
        this.stepTemplateService.get(template_id).subscribe(
          (template: FunnelStep) => {
            let stepTemplate: FunnelStep;
            if (template.static_data) {
              const { static_data, ...restData } = template;
              const staticData = {
                embed_code: static_data.embed_code || null,
                image: (static_data.image && static_data.image.id) || null,
                image_mobile: (static_data.image_mobile && static_data.image_mobile.id) || null,
                image_tablet: (static_data.image_tablet && static_data.image_tablet.id) || null,
                image_type: static_data.image_type,
              };
              //@ts-ignore
              stepTemplate = { ...restData, static_data: staticData };
            } else {
              stepTemplate = template;
            }

            if (stepTemplate) {
              this.generateStepDataFromTemplate(stepTemplate);
            }
          },
          (error) => {
            this.handleError(error);
          }
        );
      }
    }
  }

  getOfferDesc() {
    if (this.isUpsell()) {
      return PathStepsDescription.UpsellOffer.helpingText;
    }
    return PathStepsDescription.RetentionOffer.helpingText;
  }

  getOfferLabel() {
    if (this.isUpsell()) {
      return 'Upsell Offer';
    }
    return 'Retention Offer';
  }

  normalizeObject(obj: FunnelStep | FunnelInput | Action, recursive: boolean = false) {
    const fieldsToNull = ['next_step', 'step'];
    const fieldsToDelete = ['id'];
    fieldsToNull.forEach((field) => {
      obj[field] = null;
    });
    fieldsToDelete.forEach((field) => {
      delete obj[field];
    });

    if (recursive) {
      const recursiveFields = ['inputs', 'actions'];
      recursiveFields.forEach((field) => {
        if (field in obj) {
          obj[field] = obj[field].map((item) => this.normalizeObject(item, true));
        }
      });
    }
    return obj;
  }

  generateStepDataFromTemplate(template: FunnelStep) {
    this.step.template = template.id;
    this.step.inputs = [];
    template = this.normalizeObject(template, true) as FunnelStep;
    this.step = { ...this.step, ...template };

    if (this.step.id) {
      this.stepService.update(this.step.id, this.step).subscribe(
        (step: FunnelStep) => {
          if (step) {
            this.loading = false;
            this.onStepSave(step);
            this.onSave.emit(this.step);
          }
        },
        (error) => {
          this.handleError(error);
          this.loading = false;
        }
      );
    } else {
      this.stepService.create(this.step).subscribe(
        (step: FunnelStep) => {
          if (step) {
            this.onStepSave(step);
            this.onSave.emit(this.step);
            this.loading = false;
          }
        },
        (error) => {
          this.handleError(error);
          this.loading = false;
        }
      );
    }
  }

  onStepSave(step: FunnelStep) {
    this.step = step;
    this.type = step.type;
    this.category = step.category;
    this.selectedTemplateId = step.template;

    if (this.step.id) {
      this.productFunnelInputsData = [];
      this.processStepInputs(step.inputs);
    }
  }

  onStepFieldUpdate(fieldName: string, event) {
    const data = {};
    data[fieldName] = event.target.value;
    this.stepService.patch(this.step.id, data).subscribe(
      (_) => {},
      (error) => {
        this.handleError(error);
      }
    );
  }

  navigateToDownsell(stepId: number) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/steps',
        this.isUpsell() ? 'upsell' : 'downsell',
        this.isUpsell() ? OfferTypes.Upsell : OfferTypes.Downsell,
        'details',
        this.selectedDownsellId || stepId,
      ])
    );
    window.open(url, '_blank');
  }

  removeInputField(inputId: string | number, fieldName: string) {
    this.loading = true;

    this.inputService.patch(inputId, { [fieldName]: [] }).subscribe(
      () => {
        this.loading = false;
        const updatedInput = this.productFunnelInputsData.find((input) => input.id === inputId);
        if (updatedInput) {
          updatedInput.productFunnel = null;
        }
      },
      (error) => {
        this.handleError(error);
        this.loading = false;
      }
    );
  }

  onInputFieldUpdate(inputId: string | number, fieldName: string, event) {
    const dropdown = event.target as HTMLSelectElement;

    if (dropdown.value === 'new') {
      this.redirectToCreateStep(this.isUpsell() ? 'upsell' : 'downsell');
      this.resetDropdownValue(dropdown, inputId, fieldName);
      this.setupStorageListener();
    } else {
      this.onInputFieldUpdateAction(inputId, fieldName, dropdown.value);
    }
  }

  onInputFieldUpdateAction(inputId: string | number, fieldName: string, value: number | string) {
    const data = {};
    data[fieldName] = value;
    this.selectedDownsellId = Number(value);

    if (fieldName === 'product_funnels') {
      data[fieldName] = [data[fieldName]];
    }
    this.loading = true;

    if (this.productFunnelInputsData.length) {
      const updatedInput = this.productFunnelInputsData.find((input) => input.id === inputId);
      if (updatedInput) {
        updatedInput.productFunnel = Number(value);
      }
    }
    this.inputService.patch(inputId, data).subscribe(
      (input: FunnelInput) => {
        this.updateValidationState(value);
        this.loading = false;
      },
      (error) => {
        this.handleError(error);
        this.loading = false;
      }
    );
  }

  private updateValidationState(value: number | string) {
    let stepType = '';
    let isValid = value !== null && value !== undefined && value !== '';

    if (this.isUpsell()) {
      stepType = 'upsell';
    } else if (this.isSurveyStep(this.step)) {
      stepType = 'survey';
    } else {
      stepType = 'downsell';
    }

    this.updateStepValidation.emit({
      type: stepType,
      isValid: isValid,
    });
  }

  private resetDropdownValue(dropdown: HTMLSelectElement, inputId: string | number, fieldName: string): void {
    dropdown.value = null;

    const funnelInput = this.inputs.find((input) => input.id === inputId);
    if (funnelInput) {
      funnelInput[fieldName] = [null];
    }
  }

  getStepTitleLabel() {
    if (this.isConfirmation()) {
      return 'Confirmation Pop-up';
    }

    return this.step.name;
  }

  private capitalizeFirstLetter(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  getInputTitleLabel(input: FunnelInput): string {
    const intentText = IntentConfirmationButtonText[this.funnel.offer_intent];
    if (input.type === FunnelInputTypeEnum.Confirmation) {
      return `${this.capitalizeFirstLetter(intentText)} button`;
    } else if (input.type === FunnelInputTypeEnum.ConfirmationNo) {
      return `Don't ${intentText} button`;
    }
    return 'Label';
  }

  isSurveyStep(step: FunnelStep) {
    const surveyCategories: StepCategory[] = [
      CustomStepCategoryEnum.Survey,
      CustomStepCategoryEnum.CancelOrderSurvey,
      CustomStepCategoryEnum.CancelTrialSurvey,
      CustomStepCategoryEnum.CancelSubSurvey,
      CustomStepCategoryEnum.ReturnSurvey,
      CustomStepCategoryEnum.PauseSurvey,
    ];

    return surveyCategories.indexOf(step.category) > -1;
  }

  redirectToCreateStep(stepName: string): void {
    const urlPath = ['steps', stepName];
    window.open(this.router.serializeUrl(this.router.createUrlTree(urlPath)), '_blank');
  }

  deleteStep() {
    if (this.canBeDeleted) {
      this.loading = true;
      this.onDelete.emit({ step: this.step, next_step: this.nextStepId });
    }
  }

  onCloseInputDialog() {
    this.loading = true;
    let data: FunnelInput = this.inputComponent.getFormData();

    if (data) {
      this.inputService.patch(this.selectedInput.id, { actions: data.actions }).subscribe(
        (data: FunnelInput) => {
          this.loading = false;
          this.selectedInput = null;
          this.inputs.forEach((input: FunnelInput, index) => {
            if (input.id === data.id) {
              this.inputs[index].actions = data.actions;
            }
          });
        },
        (error) => {
          this.loading = false;
          this.selectedInput = null;
          this.handleError(error);
        }
      );
    }
  }

  openInputDialog(input: FunnelInput): void {
    this.selectedInput = input;
    this.modalService.getModal('inputDialog').open();
  }

  isCancelOrderType(): boolean {
    return (
      [
        OfferIntents.CancelOrder,
        OfferIntents.CancelSubscriptionHold,
        OfferIntents.CancelTrialHold,
        OfferIntents.CancelRebillHold,
      ].indexOf(
        this.funnel.offer_intent
      ) > -1
    );
  }

  isReturnOrderType(): boolean {
    return (
      [OfferIntents.ReturnOrder, OfferIntents.ReturnSubscription, OfferIntents.ReturnTrial].indexOf(
        this.funnel.offer_intent
      ) > -1
    );
  }

  ngOnDestroy() {
    window.removeEventListener('storage', this.storageListener);
  }
}
